import Parameter from '../../Parameter';
import { IParameterProperty } from '../../../../../../types/IParameter';
import { InputType } from '../../../InputTypes';

class Common extends Parameter {
  constructor(param: IParameterProperty) {
    super(param);
    if (this.type === InputType.TEXT) {
      if (param.value === null) {
        this.value = '';
        this.updateOriginalValue();
      }
    }

    if (this.type === InputType.EMAIL) {
      // Test suffix (cause it's not tested by browsers email validation)
      this.constraints.pattern =
        param.constraints && param.constraints.pattern ? param.constraints.pattern : '^.*@.*\\.[a-zA-Z]{2,}$';
    }
  }
}

export default Common;
